import { MetaView, useTable, withTable } from '@oscar/table';
import { Space } from '@oscar/theme';
import { PageHeader } from 'common/components';
import { APIS } from 'common/constants/endpoints';
import React from 'react';
import {
  columnsUserManagement,
  transReqUserManagement,
  transResUserManagement,
} from 'views/pages/utils';
import SearchTool from './components/SearchTool';
import './style.scss';

const Table = withTable({
  name: 'requests-user-management',
  keyField: 'email',
  mode: 'REMOTE',
  request: {
    name: 'user-management',
    url: APIS.USER_MANAGEMENT,
    method: 'POST',
    transformRequest: transReqUserManagement,
    transformResponse: transResUserManagement,
  },
  columns: columnsUserManagement,
});

function UserManagement() {
  const [table] = useTable();

  return (
    <div className="request-list">
      <PageHeader title="User" subtitle="Manage OSCAR users" />

      <div className="main-request-list">
        <MetaView table={table}>
          {(childProps: any) => (
            <SearchTool
              actionTable={childProps?.table}
              metadata={childProps?.metadata}
            />
          )}
        </MetaView>

        <Space size={[16, 16]} direction="vertical" className="space-table">
          <Table key="user-management" rowKey="userId" table={table} />
        </Space>
      </div>
    </div>
  );
}

export default UserManagement;
